import { css } from '@emotion/react'
import { theme, themeUtils } from 'styles/theme'

export const hitsWrapper = (expanded: boolean) => css`
  & ul,
  & ol {
    display: grid;
    grid-template-columns: repeat(${expanded ? 4 : 3}, 1fr);
    max-width: 100%;
    padding: 0;
    gap: 24px;
    @media only screen and (max-width: 1400px) {
      grid-template-columns: repeat(2, 1fr);
    }
    ${themeUtils.maxWidth.sm} {
      grid-template-columns: 1fr;
    }
  }
  & .ais-Hits-item {
    display: inline-grid;
  }
  & .ais-Hits-loadMore {
    border: 2px solid ${theme.palette.label.default};
    border-radius: 4px;
    padding: 12px 16px;
    color: ${theme.palette.label.default};
    ${themeUtils.button};
    background-color: ${theme.palette.surface.default};
    margin: 32px 0;
    cursor: pointer;
    transition: 100ms;
    &:hover {
      ${themeUtils.minWidth.md} {
        transform: scale(1.02);
      }
    }
  }
  & .ais-Hits-loadMore--disabled {
    opacity: 0;
  }
`
